<template>
  <div class="d-inline">
    <v-tooltip bottom v-if="showTootip">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on"
               @click.stop="onClickCancel"
               :loading="loading"
               :disabled="disabled">
          <v-icon>
            mdi-cancel
          </v-icon>
        </v-btn>
      </template>
      <span>Cancelar cotação</span>
    </v-tooltip>
    <v-list-item v-if="showListItem"
                 :disabled="disabled"
                 @click.stop="onClickCancel">
      <v-list-item-icon>
        <v-icon>mdi-cancel</v-icon>
      </v-list-item-icon>
      <v-list-item-content>Cancelar</v-list-item-content>
    </v-list-item>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import CotacaoService from '@/modules/cotacao/cotacao-service';

export default {
  props: {
    disabled: Boolean,
    showToast: {
      type: Boolean,
      default: true,
    },
    showTootip: {
      type: Boolean,
      default: true,
    },
    showListItem: {
      type: Boolean,
      default: false,
    },
    cotacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    cancel() {
      this.loading = true;
      CotacaoService.cancelar(this.cotacao.id)
        .then(() => {
          this.$toast('Cotação cancelada com sucesso', { color: 'success' });
          this.$emit('cancelada', this.cotacao);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickCancel() {
      this.$refs.confirm.open('Você deseja cancelar a cotação?',
        'A cotação será cancelada e não poderá mais receber respostas. Esta operação não pode ser desfeita',
        { width: 300 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.cancel();
        });
    },
  },
};
</script>
